import { render, staticRenderFns } from "./Dokumen.vue?vue&type=template&id=f68e872a&scoped=true&"
import script from "./Dokumen.vue?vue&type=script&lang=js&"
export * from "./Dokumen.vue?vue&type=script&lang=js&"
import style0 from "./Dokumen.vue?vue&type=style&index=0&id=f68e872a&prod&scoped=true&lang=css&"
import style1 from "./Dokumen.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68e872a",
  null
  
)

export default component.exports